<template>
  <nav
    class="navbar navbar-expand-lg fixed-top"
    :class="isSticky ? 'sticky-white-nav' : ''"
  >
    <div class="container-fluid" style="width: 1200px">
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        style="box-shadow: none"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <router-link class="navbar-brand logo-style" to="/">
        <img
          src="@/assets/logo.png"
          alt="Bootstrap"
          width="30"
          height="30"
          class="d-inline-block align-text-top"
        />
        柚米云
      </router-link>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0" style="margin-left: auto">
          <li
            class="nav-item"
            v-for="(item, index) in routerLinks"
            :key="index"
            :class="clickRouter == item.path ? 'navbar_bottom' : ''"
          >
            <router-link :to="item.path" v-slot="{ navigate }" custom>
              <a
                class="nav-link"
                :class="clickRouter == item.path ? 'active' : ''"
                @click="
                  (e) => {
                    e.preventDefault();
                    customNavigate(navigate, item.path);
                  }
                "
              >
                {{ item.name }}
              </a>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script setup>
import { onMounted, computed, reactive, ref, watchEffect, nextTick } from "vue";
import { useRouterStore } from "@/stores/router.js";
import throttle from "lodash/throttle";

const routerStore = useRouterStore();

const clickRouter = computed(() => routerStore.routerName);
const { setRouterName } = routerStore;

const routerLinks = reactive([
  { name: "首页", path: "/" },
  { name: "计算平台", path: "/#section1" },
  { name: "边缘网络", path: "/#section2" },
  { name: "关于我们", path: "/#section3" },
  { name: "帮助中心", path: "/#section4" },
  { name: "下载中心", path: "/download-app" },
]);

// 是否显示 sticky 样式
const isSticky = ref(false);

const handleScroll = throttle(() => {
  if (window.location.pathname === "/") {
    if (scrollY < 500) {
      setRouterName("/");
    }
    isSticky.value = scrollY > 50;
  } else {
    isSticky.value = true;
  }
}, 100);

onMounted(async () => {
  if (window.location.pathname !== "/") {
    isSticky.value = true;
  }
  window.addEventListener("scroll", handleScroll);
});

// 初始化 IntersectionObserver
const initObserver = () => {
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5, // 当50%的元素进入视口时触发
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const sectionPath = `/#${entry.target.id}`;
        setRouterName(sectionPath);
      }
    });
  }, options);

  routerLinks.forEach((section) => {
    const elementId = section.path.replace("/#", "");
    const element = document.getElementById(elementId);
    if (element) {
      observer.observe(element);
    }
  });
};

watchEffect(() => {
  nextTick(() => {
    if (routerLinks.length > 0) {
      initObserver();
    }
  });
});

const customNavigate = (navigate, path) => {
  if (path !== "/") {
    isSticky.value = true;
  } else {
    isSticky.value = false;
  }

  nextTick(() => {
    navigate();
    setRouterName(path);
  });
};
</script>
<style scoped>
.navbar.sticky-white-nav {
  background-color: white;
}
.navbar:hover {
  background-color: white;
}
.navbar:hover a {
  color: #000;
}
.navbar.sticky-white-nav a {
  color: #000;
}
.nav-item {
  position: relative;
}
.nav-item::after {
  position: absolute;
  left: 0;
  bottom: -3px;
  right: 0;
  height: 4px;
  content: "";
  background-color: #007eff;
  border-radius: 4px;
  opacity: 0;
  transform: scaleX(0);
  transition: transform 0.4s, opacity 0.4s;
}
.navbar a {
  text-decoration: none;
  cursor: pointer;
}
.navbar_bottom::after {
  opacity: 1;
  transform: scaleX(1);
}

.navbar a {
  color: #fff;
}
.sys-nav-sub-wp {
  height: 0;
  overflow: hidden;
  transition: height 0.6s ease;
  left: 0;
  position: absolute;
  right: unset;
  top: 60px;
  width: 100%;
  z-index: 4;
  background: #fff;
}
.nav-item {
  margin: 0 20px;
}
.nav-item:hover .sys-nav-sub-wp {
  height: 190px;
  border-top: 1px solid #f4f5f7;
}

.active {
  color: #007eff !important;
  font-weight: 700 !important;
}
.sys-nav-sub-wp .sys-nav-sub a {
  display: inline-block;
  line-height: 24px;
  padding: 0;
  text-align: center;
  transition: color 0.3s, background-color 0.3s;
  position: relative;
  text-decoration: none;
}
.sys-nav-sub-wp .sys-nav-sub a img {
  width: 160px;
  height: 120px;
  margin: 20px 40px 0;
}
.sys-nav-sub-wp .sys-nav-sub a h4 {
  font-weight: 600;
  font-size: 14px;
  color: #000;
}
.sys-nav-sub-wp .sys-nav-sub a:after {
  content: " ";
  width: 1px;
  height: 120px;
  background: #f4f5f7;
  position: absolute;
  right: 0;
  top: 20px;
}
.logo-style {
  display: flex;
  align-items: center;
  color: #1f7bd6 !important;
  font-weight: 700;
}

@media (max-width: 992px) {
  .nav-item::after {
    display: none;
  }
}
</style>